import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://qwolmowlbozgwomdfnzm.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF3b2xtb3dsYm96Z3dvbWRmbnptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg0MDgwMjYsImV4cCI6MjA4Mzk4NDAyNn0.04HkZPbIZ5bFfIeiIdjiqCuPP92VFAMnM1asoll_VJE'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
